import { CarsLink, CarTag, CatalogListLink } from '../types/brandSchema';

export const PopularDisksSizes: CarsLink[] = [
  {
    title: '15”',
    tags: [
      { title: '15” 4*98', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=4*98' },
      { title: '15” 4*100', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=4*100' },
      { title: '15” 4*108', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=4*108' },
      { title: '15” 4*114.3', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=4*114.3' },
      { title: '15” 5*100', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=5*100' },
      { title: '15” 5*108', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=5*108' },
      { title: '15” 5*112', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=5*112' },
      { title: '15” 5*114.3', href: '/catalog/filter/discs/?display=block&discs_diameter=15&discs_pcd=5*114.3' },
    ],
  },
  {
    title: 'R16”',
    tags: [
      { title: '16” 4*100', href: '/catalog/filter/discs/?display=block&discs_diameter=16&discs_pcd=4*100' },
      { title: '16” 4*108', href: '/catalog/filter/discs/?display=block&discs_diameter=16&discs_pcd=4*108' },
      { title: '16” 5*100', href: '/catalog/filter/discs/?display=block&discs_diameter=16&discs_pcd=5*100' },
      { title: '16” 5*108', href: '/catalog/filter/discs/?display=block&discs_diameter=16&discs_pcd=5*108' },
      { title: '16” 5*112', href: '/catalog/filter/discs/?display=block&discs_diameter=16&discs_pcd=5*112' },
      { title: '16” 5*114.3', href: '/catalog/filter/discs/?display=block&discs_diameter=16&discs_pcd=5*114.3' },
    ],
  },
  {
    title: '17”',
    tags: [
      { title: '17” 5*108', href: '/catalog/filter/discs/?display=block&discs_diameter=17&discs_pcd=5*108' },
      { title: '17” 4*100', href: '/catalog/filter/discs/?display=block&discs_diameter=17&discs_pcd=4*100' },
      { title: '17” 5*112', href: '/catalog/filter/discs/?display=block&discs_diameter=17&discs_pcd=5*112' },
      { title: '17” 5*100', href: '/catalog/filter/discs/?display=block&discs_diameter=17&discs_pcd=5*100' },
      { title: '17” 5*114.3', href: '/catalog/filter/discs/?display=block&discs_diameter=17&discs_pcd=5*114.3' },
      { title: '17” 5*120', href: '/catalog/filter/discs/?display=block&discs_diameter=17&discs_pcd=5*120' },
    ],
  },
];

export const DiscsByAuto: CarTag[] = [
  {
    title: 'диски на LADA',
    href: '/auto/disks/lada/',
  },
  {
    title: 'диски на Audi',
    href: '/auto/disks/audi/',
  },
  {
    title: 'диски на BMW',
    href: '/auto/disks/bmw/',
  },
  {
    title: 'диски на Hyundai',
    href: '/auto/disks/hyundai/',
  },
  {
    title: 'диски на KIA',
    href: '/auto/disks/kia/',
  },
  {
    title: 'диски на Mercedes',
    href: '/auto/disks/mercedes/',
  },
  {
    title: 'диски на Nissan',
    href: '/auto/disks/nissan/',
  },
  {
    title: 'диски на Skoda',
    href: '/auto/disks/skoda/',
  },
];

export const Diams: CarTag[] = [
  {
    title: '13”',
    href: '/catalog/discs/r13/',
  },
  {
    title: '14”',
    href: '/catalog/discs/r14/',
  },
  {
    title: '15”',
    href: '/catalog/discs/r15/',
  },
  {
    title: '16”',
    href: '/catalog/discs/r16/',
  },
  {
    title: '17”',
    href: '/catalog/discs/r17/',
  },
  {
    title: '18”',
    href: '/catalog/discs/r18/',
  },
  {
    title: '19”',
    href: '/catalog/discs/r19/',
  },
  {
    title: '20”',
    href: '/catalog/discs/r20/',
  },
  {
    title: 'Все размеры',
    href: '/catalog/discs/all_sizes/',
  },
];

export const CatalogListDisk: CatalogListLink[] = [
  {
    title: 'Литые диски',
    image: '/next/img/catalog/discs/cast.png',
    href: '/catalog/discs/litye/',
    testid: 'catalog-discs-litye',
  },
  {
    title: 'Штампованные диски',
    image: '/next/img/catalog/discs/steel.png',
    href: '/catalog/discs/shtampov/',
    testid: 'catalog-discs-shtampov',
  },
  {
    title: 'Кованые диски',
    image: '/next/img/catalog/discs/forged.png',
    href: '/catalog/discs/kovanye/',
    testid: 'catalog-discs-kovanye',
  },
  {
    title: 'Грузовые диски',
    image: '/next/img/catalog/discs/trucks.png',
    href: '/catalog/discs/trucks/',
    testid: 'catalog-discs-trucks',
  },
  {
    title: 'Диски реплика',
    image: '/next/img/catalog/discs/repl.png',
    href: '/auto/disks-replika/',
    testid: 'catalog-discs-replika',
  },
  {
    title: 'Индивидуальный дизайн',
    image: '/next/img/catalog/discs/individ.png',
    href: 'https://exclusive.koleso.ru/',
    testid: 'catalog-discs-individ',
  },
];
